import { render, staticRenderFns } from "./AltirisSearch.vue?vue&type=template&id=225f84d4"
import script from "./AltirisSearch.vue?vue&type=script&lang=js"
export * from "./AltirisSearch.vue?vue&type=script&lang=js"
import style0 from "./AltirisSearch.vue?vue&type=style&index=0&id=225f84d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports